<dashboard-loader *ngIf="loadingSections$ | async" [title]="'Loading sections...'"></dashboard-loader>
<div *ngIf="sectionsLoaded$ | async">
  <div class="dashboard-sections" fxLayout="column" fxLayoutAlign=" start" fxLayoutGap="20px">
    <h1 class="dashboard-sections-title">{{ selectedTemplate?.templateName }}</h1>
    <div fxLayout="column" fxLayoutAlign=" end" fxFill>
      <button mat-raised-button color="accent" (click)="openCreateSectionDialog()">
        {{ 'Add Section' | uppercase }}
      </button>
    </div>
  </div>
  <div
    *ngIf="sections.length"
    class="dashboard-sections__sections"
    cdkDropListGroup
    fxLayout="row"
    fxLayoutAlign="space-between start"
    fxLayoutGap="20px"
  >
    <div
      fxFlex="100"
      cdkDropList
      id="sections"
      [cdkDropListData]="sections"
      class="dashboard-sections__sections-list"
      (cdkDropListDropped)="dropSection($event)"
    >
      <div *ngFor="let section of sections" cdkDrag>
        <div class="dashboard-sections__sections-box" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="6px">
          <div class="dashboard-sections__sections-box-label">
            {{ section?.sectionName }}
          </div>
          <div fxLayout="row" fxLayoutAlign="end">
            <button mat-button color="warn" (click)="openDeleteSectionDialog(section)">
              {{ 'Delete' | uppercase }}
            </button>
            <button mat-button (click)="openUpdateSectionDialog(section)">{{ 'Edit' | uppercase }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
